<div *ngIf="isSuccess" class="flex justify-center gap-4">
  <button
    mat-raised-button
    class="px-4 py-2 bg-brand-surface-muted text-brand-text-secondary hover:bg-brand-border-muted text-sm rounded-m"
    (click)="volver()"
  >
    Volver
  </button>

  <button
    mat-raised-button
    class="bg-brand-primary text-brand-surface px-4 py-2 rounded-md hover:bg-brand-primary-hover text-sm disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="getPDF()"
  >
    Generar PDF
  </button>
</div>

<div *ngIf="isSuccess" id="infoPdf" class="pdf-wrapper">
  <div #pdfContent>
    <div class="pdf-template">
      <div id="watermark" class="watermark">DOCUMENTO INFOMÁTIVO</div>
      <title>Acta de Cálculo de Derechos</title>

      <div class="header">
        <div style="flex: 0 0 120px">
          <img
            [src]="cfg.project.logo"
            [alt]="'Logo ' + cfg.project.name"
            style="max-width: 200px"
          />
        </div>
        <div class="cuadro-solicitud">
          <div class="row-title">Folio</div>
          <div class="row-value">
            {{ dataId }}
          </div>
          <div class="row-title">Fecha Ingreso</div>
          <div class="row-value">
            {{ expediente_info?.actaCalculoDerecho?.fechaIngreso }}
          </div>
          <div class="row-title">Fecha Emisión</div>
          <div class="row-value">
            {{ expediente_info?.actaCalculoDerecho?.fechaEmision }}
          </div>
        </div>
      </div>

      <div class="header-center">
        <h1>CÁLCULO DE DERECHOS MUNICIPALES DE EDIFICACIÓN</h1>
        <h1>LEY 20.958</h1>
        <div class="subtitulo-copiapo">
          <p>Aporte al Espacio Público</p>
          <p>DIRECCIÓN DE OBRAS MUNICIPALES</p>
          <p><strong>I. MUNICIPALIDAD DE TALCA</strong></p>
        </div>
      </div>
      <br />

      <!-- ====== DATOS DEL EXPEDIENTE ====== -->
      <div class="datos-expediente">
        <div class="row-title">Expediente:</div>
        <div class="row-value">
          {{ expediente_info?.expediente }}
        </div>

        <div class="row-title">Propietario:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.propietario
              ? expediente_info?.profesionales?.propietario
              : ""
          }}
        </div>

        <div class="row-title">Representante:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.representante
              ? expediente_info?.profesionales?.representante
              : ""
          }}
        </div>

        <div class="row-title">Arquitecto:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.arquitecto
              ? expediente_info?.profesionales?.arquitecto
              : ""
          }}
        </div>

        <div class="row-title">Ubicación:</div>
        <div class="row-value">
          {{ expediente_info?.propiedad ? expediente_info?.propiedad : "" }}
        </div>

        <div class="row-title">ROL:</div>
        <div class="row-value">
          {{ expediente_info?.rol ? expediente_info?.rol : "" }}
        </div>

        <div class="row-title">Materia:</div>
        <div class="row-value">
          {{ expediente_info?.tipoTramite ? expediente_info?.tipoTramite : "" }}
        </div>

        <div class="row-title">Tema:</div>
        <div class="row-value">
          {{ expediente_info?.temaTramite ? expediente_info?.temaTramite : "" }}
        </div>
      </div>

      <!-- ====== BLOQUE CÁLCULO DE DERECHOS MUNICIPALES ====== -->
      <div class="calculo-derechos">
        <div class="calculo-header">
          <strong>CÁLCULO DE DERECHOS MUNICIPALES</strong>
        </div>

        <div class="calculo-fila">
          <div class="calculo-label">
            Total a Pagar:
            {{
              this.expediente_info?.actaCalculoDerecho?.totalPagar
                ? this.expediente_info?.actaCalculoDerecho?.totalPagar
                : 0
            }}
          </div>
        </div>
      </div>

      <div class="firmas-container">
        <div class="firma-item">
          <img
            *ngIf="firmaUrlArquitecto"
            [src]="firmaUrlArquitecto"
            alt="Firma funcionario"
            class="firma-img"
          />
          <div class="firma-texto">
            <p>
              <strong>
                {{
                  expediente_info?.actaObservaciones?.firmas?.revisor?.nombre
                }}
              </strong>
            </p>
            <p><strong>ARQUITECTO REVISOR</strong></p>
          </div>
        </div>

        <div class="firma-item derecha">
          <img
            [src]="firmaUrlDirector || 'assets/firmas/director.png'"
            alt="Firma director"
            class="firma-img"
          />
          <div class="firma-texto">
            <p>
              <strong>
                {{
                  expediente_info?.actaObservaciones?.firmas?.director?.nombre
                }}
              </strong>
            </p>
            <p><strong>DIRECTOR DE OBRAS MUNICIPALES</strong></p>
          </div>
        </div>
      </div>
      <div class="nota-abreviaturas">
        <p>
          Este documento es de caracter informátivo. Para trámites legales,
          deberá solicitar la copia original en la Dirección de Obras
          Municipales
        </p>
      </div>
    </div>
  </div>
</div>

<html *ngIf="!isSuccess" class="h-full w-full m-0 p-0">
  <head>
    <meta charset="UTF-8" />
    <script src="https://cdn.tailwindcss.com"></script>
    <title>No accesible</title>
  </head>
  <body
    class="fixed inset-0 m-0 p-0 flex items-center justify-center bg-gray-100"
  >
    <div class="bg-white rounded-lg shadow-md p-8 text-center max-w-md">
      <div class="flex justify-center mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      <h1 class="text-lg font-semibold text-gray-800 mb-2">
        No es posible acceder a este contenido
      </h1>
      <p class="text-gray-600 text-sm">
        Puede que no tengas los permisos necesarios o el recurso ya no esté
        disponible.
      </p>
    </div>
  </body>
</html>

<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>
